import { DatePipe } from "@angular/common";
import { Component, input } from "@angular/core";
import { PeriodDefinitionType } from "@models/map/market-filter.model";

@Component({
    selector: "subscription-range-infographics",
    imports: [DatePipe],
    templateUrl: "./subscription-range-infographics.component.html",
    styleUrl: "./subscription-range-infographics.component.scss",
})
export class SubscriptionRangeInfographicsComponent {
    fromDate = input<Date>();
    toDate = input<Date>();
    saleSelection = input<PeriodDefinitionType>(PeriodDefinitionType.InMarket);
    smallMode = input<boolean>(true);

    periodDefinitionType = PeriodDefinitionType;
}
